import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

function FaqItem({ q, a }) {
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography color="text.secondary">{a}</Typography>
            </AccordionDetails>
        </Accordion>
    );
}

export default function LandingFaqSection() {
    return (
        <>
            <Typography variant="h4" align="center" fontWeight={800} gutterBottom>
                Häufige Fragen
            </Typography>
            <Box sx={{ mt: 3 }}>
                <FaqItem q="Gibt es eine Mindestlaufzeit?" a="Nein. Du kannst monatlich kündigen – ohne Kleingedrucktes." />
                <FaqItem
                    q="Ist der Preis inklusive aller Funktionen?"
                    a="Ja. Der Pro-Tarif enthält OCR und Auswertungen. Es gibt keine versteckten Add-ons."
                />
                <FaqItem
                    q="Wie sicher sind meine Daten?"
                    a="Verschlüsselte Speicherung, EU-Server, DSGVO-konform. Deine Daten gehören dir."
                />
                <FaqItem
                    q="Unterstützt ihr die Kleinunternehmerregelung?"
                    a="Ja. Bei aktivierter KUR wird keine Umsatzsteuer ausgewiesen – automatisch auf Rechnungen und in der Vorschau."
                />
                <FaqItem
                    q="Kann ich jederzeit von einem anderen Tool wechseln?"
                    a="Klar. Importiere Kontakte, Artikel und Belege per CSV/Upload – in wenigen Minuten."
                />
            </Box>
        </>
    );
}
